import { NgModule } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'

import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
import { NZ_I18N } from 'ng-zorro-antd/i18n'
import { ar_EG } from 'ng-zorro-antd/i18n'
import { registerLocaleData } from '@angular/common'
import ar from '@angular/common/locales/ar'
import { FormsModule } from '@angular/forms'
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { IconsProviderModule } from './icons-provider.module'
import { NzLayoutModule } from 'ng-zorro-antd/layout'
import { NzMenuModule } from 'ng-zorro-antd/menu'
import { MyHttpInterceptorInterceptor } from './interceptor/my-http-interceptor'
import { SpinnerComponent } from './shared/spinner/spinner.component'
import { NzSpinModule } from 'ng-zorro-antd/spin'
import { NzModalModule } from 'ng-zorro-antd/modal'
import { NzEmptyModule } from 'ng-zorro-antd/empty'
import { NzBreadCrumbModule } from 'ng-zorro-antd/breadcrumb'
import { NzDropDownModule } from 'ng-zorro-antd/dropdown'
import { NzTabsModule } from 'ng-zorro-antd/tabs'
import { NzPageHeaderModule } from 'ng-zorro-antd/page-header'
import { TabHubComponent } from './core/navigation/tab-hub/tab-hub.component'
import { CommandPaletteComponent } from './core/navigation/command-palette/command-palette.component'
import * as moment from 'moment-timezone'

registerLocaleData(ar)

@NgModule({
  declarations: [AppComponent, SpinnerComponent, CommandPaletteComponent, TabHubComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    IconsProviderModule,
    NzLayoutModule,
    NzMenuModule,
    NzSpinModule,
    NzModalModule,
    NzEmptyModule,
    NzBreadCrumbModule,
    NzDropDownModule,
    NzTabsModule,
    NzPageHeaderModule,
  ],
  providers: [
    { provide: NZ_I18N, useValue: ar_EG },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MyHttpInterceptorInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
  exports: [SpinnerComponent],
})
export class AppModule {
  constructor() {
    // Set default time zone to Riyadh, Saudi Arabia (Arabia Standard Time)
    // moment.tz.setDefault('Asia/Riyadh');
  }
}
